// frontend/src/components/ScrollToTop.tsx
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function ScrollToTop() {
  // Only reset scroll on a real route (pathname) change. Same-page query-string
  // updates — e.g. the /blog category filter writing ?category=... — must NOT
  // jerk the page back to the top; the user should stay where they are.
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export default ScrollToTop
